import React from 'react'
import { getNavBadges } from '../../api/nav.api'

const POLL_MS = 60_000
// Perpindahan halaman beruntun (mis. sambutan → dasbor saat masuk) tidak perlu
// masing-masing memanggil server.
const PAGE_REFRESH_MIN_MS = 5_000

// Angka "menunggu tindakan" untuk menu sidebar admin: { [idMenu]: jumlah }.
//
// Hanya admin yang punya pekerjaan seperti ini (server mengembalikan objek kosong
// untuk peran lain), jadi peran lain tidak memanggil apa pun.
//
// Kapan menyegarkan:
//  - saat program/kelas aktif berganti — angkanya lama dikosongkan dulu, supaya
//    angka milik program sebelumnya tidak tampil di program yang baru;
//  - tiap 60 dtk, tetapi tidak saat tab tersembunyi;
//  - saat tab kembali terlihat;
//  - setiap pindah halaman, karena menyelesaikan pekerjaan (mengirim kode,
//    menyetujui dokumen) hampir selalu diikuti pindah halaman.
// Galat diabaikan: badge itu kenyamanan, dan angka lama lebih baik daripada
// sidebar yang berkedip kosong saat jaringan sebentar putus.
export function useNavBadges({ enabled, programId, classId, page }) {
  const [badges, setBadges] = React.useState({})
  const seq = React.useRef(0)
  const lastFetch = React.useRef(0)

  const refresh = React.useCallback(() => {
    if (!enabled || !programId) return
    const mine = ++seq.current
    lastFetch.current = Date.now()
    getNavBadges({ programId, classId })
      .then((next) => { if (mine === seq.current) setBadges(next) })
      .catch(() => {})
  }, [enabled, programId, classId])

  // Konteks berganti → buang angka lama, lalu ambil yang baru.
  React.useEffect(() => {
    setBadges({})
    refresh()
    return () => { seq.current++ } // jawaban yang masih terbang dianggap basi
  }, [refresh])

  React.useEffect(() => {
    if (!enabled) return undefined
    const tick = () => { if (!document.hidden) refresh() }
    const id = setInterval(tick, POLL_MS)
    document.addEventListener('visibilitychange', tick)
    return () => {
      clearInterval(id)
      document.removeEventListener('visibilitychange', tick)
    }
  }, [enabled, refresh])

  // Pindah halaman: segarkan (lewati render pertama, sudah ditangani di atas).
  const firstPage = React.useRef(true)
  React.useEffect(() => {
    if (firstPage.current) { firstPage.current = false; return }
    if (Date.now() - lastFetch.current < PAGE_REFRESH_MIN_MS) return
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return badges
}
